import React from "react";

import { Stack, Typography, Link } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { Trans, useTranslation } from "react-i18next";

import Banner from "./Banner";
import Nickname from "./Nickname";

const Atlas: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={3}>
      <Banner />
      <Stack spacing={2}>
        <Typography color={"white"} fontSize={{ xs: "0.875rem", md: "1.375rem" }} fontWeight={fontWeight.semiBold}>
          {t("dashboard.communityHub.atlas.title")}
        </Typography>
        <Typography
          color={"white"}
          fontSize={{ xs: "0.75rem", md: "1rem" }}
          fontWeight={fontWeight.light}
          textAlign={"left"}>
          <Trans
            i18nKey="dashboard.communityHub.atlas.description"
            components={{
              a: <Link href={"/atlas#podporovatele"} fontWeight={fontWeight.semiBold} />,
            }}
          />
        </Typography>
      </Stack>
      <Nickname />
    </Stack>
  );
};

export default Atlas;
